import { render, staticRenderFns } from "./WardGroup.vue?vue&type=template&id=32f3787f&scoped=true"
import script from "./WardGroup.vue?vue&type=script&lang=js"
export * from "./WardGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f3787f",
  null
  
)

export default component.exports